import React, { FC } from 'react'

import { Txt } from 'src/components/atoms'

type Props = {
  title: string
  heightRem?: number
  children: React.ReactNode
  className?: string
}

export const UserDetailManagementContentItem: FC<Props> = ({
  title,
  heightRem,
  children,
  className,
}) => {
  return (
    <div className={className}>
      <div className={`tw-flex tw-items-start height: ${heightRem ? `${heightRem}rem` : 'auto'}`}>
        <div className="tw-w-[8.93rem] tw-shrink-0">
          <Txt className="tw-text-standardText-secondary">{title}</Txt>
        </div>
        <div className="tw-flex tw-flex-col tw-w-full">{children}</div>
      </div>
    </div>
  )
}
